import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/consumoProducto';
import ConsumoProducto from './ConsumoProducto';

const ms2p = (state) => {
  return {
    ...state.inv_consumo_producto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ConsumoProducto);
